<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout justify-center wrap>
      <v-flex md12>
        <material-card color="green" title="图书" text="图书列表">
          <v-layout row wrap class="mx-3">
            <v-layout row wrap xs12>
              <v-flex sm3>
                <v-text-field
                  hide-details
                  label="书名"
                  v-model="searchName"
                  v-on:keyup.enter="onClickSearch"
                ></v-text-field>
              </v-flex>
              <v-flex sm3 class="text-no-wrap">
                <v-btn color="orange" dark class="mx-2" @click="onClickReset">重置</v-btn>
                <v-btn color="green" dark @click="onClickSearch">查询</v-btn>
              </v-flex>
            </v-layout>
            <v-flex xs12>
              <v-data-table
                :headers="headers"
                :items="items"
                :total-items="totalItems"
                :pagination.sync="pagination"
                :rows-per-page-items="rowsPerPageItems"
                :disable-initial-sort="true"
              >
                <template slot="headerCell" slot-scope="{ header }">
                  <span
                    class="subheading font-weight text-success text--darken-3"
                    v-text="header.text"
                  />
                </template>
                <template slot="items" slot-scope="{ item }">
                  <td>{{ item.id }}</td>
                  <td>{{ "《" + item.name + "》" }}</td>
                  <td>{{ item.summary }}</td>
                  <td>
                    <v-icon v-if="item.enabled === 1" color="green">mdi-check-circle-outline</v-icon>
                    <v-icon v-else color="red">mdi-close-circle</v-icon>
                  </td>
                  <td>{{ formateDate(item.updatedAt) }}</td>
                  <td>
                    <a v-if="item.mainImage" target="_blank" :href="item.mainImage">封面</a>
                    &nbsp;|&nbsp;
                    <a
                      v-if="item.wxaCode"
                      target="_blank"
                      :href="item.wxaCode"
                    >二维码</a>
                  </td>
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
        </material-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import dayjs from 'dayjs'
import { getBooksByPage } from '@/services'

export default {
  data: () => ({
    headers: [
      {
        text: 'ID',
        value: 'id'
      },
      {
        text: '书名',
        value: 'name'
      },
      {
        text: '概要',
        value: 'summary'
      },
      {
        text: '可否漂流',
        value: 'enabled'
      },
      {
        text: '同步时间',
        value: 'updatedAt'
      },
      {
        text: '操作',
        value: '',
        sortable: false
      }
    ],
    items: [],
    rowsPerPageItems: [2, 5, 10, 20, 50],
    pagination: {
      page: 1,
      rowsPerPage: 5,
      descending: false,
      sortBy: null
    },
    criteria: [],
    searchName: null,
    newKeyword: ''
  }),

  computed: {
    tempParams() {
      return {
        descending: this.pagination.descending || null,
        page: this.pagination.page || null,
        rowsPerPage: this.pagination.rowsPerPage || null,
        sortBy: this.pagination.sortBy || null
      }
    },

    totalItems() {
      return (this.pagination && this.pagination.totalItems) || 0
    }
  },

  watch: {
    tempParams: {
      async handler(oldValue, newValue) {
        // console.log('oldValue', JSON.stringify(oldValue))
        if (JSON.stringify(oldValue) === JSON.stringify(newValue)) {
          return
        }
        // console.log('newValue', JSON.stringify(newValue))
        await this.fetchData()
      }
    }
  },

  async beforeMount() {
    await this.fetchData()
  },

  methods: {
    async fetchData() {
      let pagination = await getBooksByPage({
        ...this.pagination,
        criteria: this.criteria
      })

      if (pagination) {
        // remove items from pagination
        this.pagination = { ...pagination, items: [] }
        this.items = pagination.items
      }
    },

    formateDate(x) {
      return dayjs(x).format('YYYY-MM-DD HH:mm')
    },

    async onClickSearch() {
      let criteria = []
      if (this.searchName) {
        criteria.push({
          name: 'name',
          op: 'like',
          value: `%${this.searchName.replace(/《|》/g, '').trim()}%`
        })
      }

      this.criteria = criteria
      await this.fetchData()
    },

    async onClickReset() {
      this.criteria = []
      this.searchName = null
      await this.fetchData()
    }
  }
}
</script>
